import React from 'react'
import styles from './Messages.scss'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getExperienceId } from '../ExperiencesApp/ExperiencesApp'
import { experienceSelectors, experienceActions } from 'data/resources/experiences'
import { experienceMessageSelectors, experienceMessageActions } from 'data/resources/experienceMessages'
import { SingleMessageDialog, SINGLE_MESSAGE_DIALOG } from './SingleMessageDialog'
import { CreateMessageDialog, CREATE_MESSAGE_DIALOG } from './CreateMessageDialog'
import { ColWrap, MainCol, SecondaryCol } from 'common/layouts/SideNavLayout/TwoCol'
import { SectionBox } from 'common/styleguide/SectionBox'
import { CTA } from 'common/styleguide/CTA'
import { Loadable } from 'common/Loadable'
import { Icon } from 'common/Icon'
import { clampString } from 'lib/utils'
import { useHover } from 'lib/hooks/useHover'
import smartDate from '@qrohlf/smart-date'
import cx from 'classnames'
import Helmet from 'react-helmet'

export class _Messages extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      dialog: null,
      messageToShow: null
    }
  }

  setDialog = (dialog) => {
    this.setState({ dialog })
  }

  clearDialog = () => {
    this.setState({ dialog: null, messageToShow: null })
  }

  showSingleMessage = (message) => {
    this.setState({ messageToShow: message, dialog: SINGLE_MESSAGE_DIALOG })
  }

  render () {
    const { experience, messagesForExperience } = this.props
    const { dialog, messageToShow } = this.state

    return (
      <ColWrap>
        {experience && <Helmet title={experience.name} />}
        {dialog === SINGLE_MESSAGE_DIALOG && <SingleMessageDialog message={messageToShow} onRequestClose={() => this.clearDialog()} />}
        {dialog === CREATE_MESSAGE_DIALOG && <CreateMessageDialog experienceId={experience.id} onRequestClose={() => this.clearDialog()} />}
        <MainCol>
          <SectionBox title='message history' className={styles.messages}>
            {messagesForExperience.size > 0
              ? messagesForExperience.map(message => <ExperienceMessageRow
                key={message.id}
                message={message}
                dialog={dialog}
                showSingleMessage={(m) => this.showSingleMessage(m)} />)
              : <EmptyMessages />}
          </SectionBox>
        </MainCol>
        <SecondaryCol >
          <SectionBox title='new message'>
            <div className={styles.newMessage}>Create a new message to send to your guests.</div>
            <CTA
              onClick={() => this.setDialog(CREATE_MESSAGE_DIALOG)}
              margins={false}>Create Message</CTA>
          </SectionBox>
        </SecondaryCol>
      </ColWrap>
    )
  }
}

const ExperienceMessageRow = ({ message, dialog, showSingleMessage }) => {
  const [hoverRef, isHovered] = useHover()

  return <div
    onClick={() => showSingleMessage(message)}
    className={cx(styles.row, isHovered && styles.hovered)}
    ref={hoverRef}>
    <div className={styles.content}>
      {clampString(message.content, 180)}
    </div>
    <div className={styles.createdAt}>
      {smartDate(message.createdAt, { relative: 'day' })}
    </div>
  </div>
}

const EmptyMessages = () => <div className={styles.empty}>
  <Icon i='empty-messages' size={100} />
  <div className={styles.explainer}>You have not created any new messages</div>
</div>

const loadInitialData = ({ loadExperience, loadExperienceMessages }) => {
  return Promise.all([loadExperience(), loadExperienceMessages()])
}

const LoadableMessages = (props) => {
  return <Loadable
    {...props}
    component={_Messages}
    loadingText='Loading experience messages'
    resourceLoaded={() => loadInitialData(props)} />
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    loadExperience: () => dispatch(experienceActions.read(experienceId)),
    loadExperienceMessages: () => dispatch(experienceMessageActions.loadAll({ experienceId }))
  }
}

const mapStateToProps = (state, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  const messagesForExperience = experienceMessageSelectors
    .byExperienceId(state, experienceId)
    .sortBy(message => message.createdAt)
    .reverse()

  return {
    experience: experienceSelectors.find(state, experienceId),
    messagesForExperience
  }
}

export const Messages = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadableMessages))
